import { pickDefaultSite } from 'features/orgAndSiteSourceOfTruth/resolveActiveOrgSite'
import { ORG_SITE_ENTRIES_QUERY } from 'features/orgAndSiteSourceOfTruth/useOrgSiteEntries'
import { useRolodexEntries } from 'features/rolodex'
import { useMemo } from 'react'
import { RolodexEntryType } from 'types'

export type DefaultOrgSiteReturn =
  | {
      isLoading: true
      hasError: false
    }
  | {
      isLoading: false
      siteId: string
      organizationId: string
      hasError: false
    }
  | {
      isLoading: false
      hasError: true
      error: Error
    }

export function useGetDefaultOrgSite(): DefaultOrgSiteReturn {
  const { sites, isLoading, hasEverLoaded } = useRolodexEntries(
    ORG_SITE_ENTRIES_QUERY
  )

  const siteToUse = pickDefaultSite(sites)

  return useMemo(() => {
    if (isLoading || !hasEverLoaded) {
      return { isLoading: true, hasError: false }
    }

    if (!siteToUse) {
      return {
        isLoading: false,
        hasError: true,
        error: new Error(
          'User has access to no sites nor organizations. Please contact support.'
        ),
      }
    }

    return {
      isLoading: false,
      hasError: false,
      siteId: siteToUse.id,
      organizationId: siteToUse.tags[RolodexEntryType.ORGANIZATION],
    }
  }, [isLoading, hasEverLoaded, siteToUse])
}
